<template>
  <div>
    <div>
      <px-view-header title="Cadastro de compra" title-class="font-weight-bold"
                      :breadcrumbs="breadcrumbs">
        <template v-slot:before>
          <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
            <v-icon>
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
      </px-view-header>
      <div v-if="loadingForm">
        <px-circular-loading/>
      </div>
      <v-stepper v-if="!loadingForm"
                 class="elevation-1 rounded-card"
                 v-model="currentStep"
                 vertical>

        <v-stepper-step :complete="currentStep > 1" step="1">
          Condições e frete
        </v-stepper-step>
        <v-stepper-content step="1">
          <px-cadastro-compra-dados-basicos is-from-solicitacao
                                            :compra="compra"
                                            :cadastros-adicionais="cadastrosAdicionais"
                                            :erp-campos-integracao="erpCamposIntegracao"
                                            :campos-obrigatorios="camposObrigatorios"
                                            :usa-tabela-preco="true"
                                            @change-fornecedor="getDetalhesFornecedor"
                                            @ready="next"
                                            @cancel="onClickCancel"/>
        </v-stepper-content>

        <v-stepper-step :complete="currentStep > 2" step="2">Notificações</v-stepper-step>
        <v-stepper-content step="2">
          <px-notificar-fornecedor :compra="compra"
                                   @remove="onRemoveMessage"
                                   @ready="next"
                                   @previous="previous"/>
        </v-stepper-content>

        <v-stepper-step :complete="currentStep > 3" step="3">Produtos</v-stepper-step>
        <v-stepper-content step="3">
          <px-cadastro-compra-produtos :compra="compra"
                                       :erp-campos-integracao="erpCamposIntegracao"
                                       :campos-obrigatorios="camposObrigatorios"
                                       :usa-tabela-preco="true"
                                       @ready="onClickSalvar"
                                       @previous="previous"
                                       @save-draft="onSaveDraft"/>
        </v-stepper-content>
        <px-confirm-dialog ref="confirm"/>
      </v-stepper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import CompradorService from '@/api/comprador-service';
import CompraService from '@/modules/compra/compra-service';
import pxCadastroCompraProdutos from '@/modules/compra/cadastro/CadastroCompraProdutos.vue';
import pxNotificarFornecedor from '@/modules/compra/cadastro/CadastroNotificarFornecedor.vue';
import pxCadastroCompraDadosBasicos from '@/modules/compra/cadastro/CadastroCompraDadosBasicos.vue';
import {
  AplicacaoImposto,
  FinalidadeCompra,
  OrigemCompra,
  SituacaoRequisicao,
} from 'px-business-components';
import {
  initialStateCamposErp,
} from '@/modules/carrinho/finalizacao/campos-erp/validate-campos-erp';
import GestaoFornecedorService from '@/modules/gestao-fornecedor/gestao-fornecedor-service';
import { getCadastroAdicional } from '@/modules/cadastros-adicionais/cadastros-adicionais-utils';
import { getTipoAplicacaoIcms, getTipoAplicacaoIpi } from '@/utils/imposto-utils';
import { formatToCode } from '@/utils/moment-date-utils';
import { uniqueId } from 'lodash';
import { calcularSaving } from '@/modules/compra/cadastro/calculo-compra.service';
import EntidadeCamposCompraService
  from '@/modules/erp-campos-obrigatorios/entidade-campos-compra-service';
import TipoNotaEntradaService from '../../tipo-nota-entrada/tipo-nota-entrada-service';

export default {
  components: { pxCadastroCompraDadosBasicos, pxNotificarFornecedor, pxCadastroCompraProdutos },
  data() {
    return {
      currentStep: 1,
      idRequisicao: this.$route.query.idRequisicao,
      idsRequisicoes: this.$route.query.idsRequisicoes,
      isRascunho: this.$route.params.isRascunho,
      idCompra: null,
      formDirty: true,
      loadingForm: false,
      cadastrosAdicionais: null,
      camposObrigatorios: null,
      compra: {
        comprador: null,
        compradorEntrega: null,
        dataCompra: null,
        fornecedor: null,
        centroCusto: null,
        projeto: null,
        transportadora: null,
        formaPagamento: null,
        prazoPagamento: null,
        dataFaturamento: null,
        observacao: null,
        situacao: null,
        mensagem: null,
        saving: null,
        notificaFornecedor: false,
        finalidadeCompra: FinalidadeCompra.keys.USO_CONSUMO.key,
        origemCompra: OrigemCompra.keys.CADASTRO.key,
        modoPagamento: null,
        frete: {
          tipoFrete: null,
          prazoEntrega: null,
          totalTransporte: null,
        },
        arquivos: [],
        produtos: [],
        mensagensPersonalizadas: [],
        dataNecessidadeEntregaSolicitacao: null,
        tipoNotaEntrada: null,
      },
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Compras',
          to: '/compras',
        },
        { text: 'Cadastro de compras' },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['erpCamposIntegracao']),
    messageConfirm() {
      return this.isRascunho ? 'Você deseja atualizar este rascunho?' : 'Você deseja salvar esta compra como rascunho?';
    },
    checkCadastrosAdicionais() {
      return !this.cadastrosAdicionais
        && (!this.cadastrosAdicionais.natureza || !this.cadastrosAdicionais.condicaoPagamento);
    },
    checkCadastrosAdicionaisProduto() {
      return produto => !produto.cadastrosAdicionais && !produto.produto.cadastrosAdicionais;
    },
  },
  methods: {
    onRemoveMessage(item) {
      this.compra.mensagensPersonalizadas = this.compra
        .mensagensPersonalizadas.filter(mensagem => mensagem.id !== item.id);
    },
    checkIsProdutoValido(situacao) {
      return ![SituacaoRequisicao.keys.CANCELADA.key, SituacaoRequisicao.keys.FINALIZADA.key]
        .includes(situacao);
    },
    onSaveDraft() {
      this.saveDraft();
    },
    onClickCancel() {
      if (this.idRequisicao) {
        this.$router.push({
          name: 'main.requiscao.detalhes',
          params: {
            id: this.idRequisicao,
          },
        });
        return;
      }
      this.$router.push({ name: 'main.compras' });
    },
    next() {
      this.currentStep = this.currentStep + 1;
    },
    previous() {
      this.currentStep = this.currentStep - 1;
    },
    getCompra() {
      if (this.idRequisicao) {
        return this.getCompraFromRequisicao();
      }
      return this.getCompraFromRequisicoes();
    },
    getEspecificacao(produto) {
      if (produto.especificacaoProduto) {
        return produto.especificacaoProduto;
      }
      if (produto.especificacaoProdutoOrigem) {
        return produto.especificacaoProdutoOrigem;
      }
      return produto.produto ? produto.produto.especificacaoProduto : null;
    },
    mapCompra(data) {
      this.compra = {
        ...data,
        id: undefined,
        dataCompra: formatToCode(moment()),
        dataFaturamento: formatToCode(moment()),
      };
      this.compra.produtos = this.compra.produtos
        .filter(produto => this.checkIsProdutoValido(produto.requisicaoProduto.situacao))
        .map(produto => ({
          ...produto,
          $$id: uniqueId(),
          cadastrosAdicionais: this.getCadastrosAdicionaisProduto(produto),
          especificacaoProduto: this.getEspecificacao(produto),
          precoUnitario: 0,
          impostos: {
            tipoAplicacaoIcms: AplicacaoImposto.keys.ISENTO.key,
            tipoAplicacaoIpi: AplicacaoImposto.keys.ISENTO.key,
            icms: 0,
            ipi: 0,
          },
        }));
    },
    getCadastrosAdicionaisProduto(produto) {
      const cadastrosAdicionais = [];
      if (produto.cadastrosAdicionais && produto.cadastrosAdicionais.length) {
        cadastrosAdicionais.push(...produto.cadastrosAdicionais);
      }

      if (produto.produto && produto.produto.cadastrosAdicionais) {
        const tiposUsados = cadastrosAdicionais.map(cadastro => cadastro.tipo);
        const cadastrosAdicionaisFromProduto = produto.produto.cadastrosAdicionais
          .filter(cadastro => !tiposUsados.includes(cadastro.tipo));
        cadastrosAdicionais.push(...cadastrosAdicionaisFromProduto);
      }

      return cadastrosAdicionais.length ? cadastrosAdicionais : null;
    },
    getCompraFromRequisicoes() {
      const requisicoesProdutos = this.idsRequisicoes.split(',').map(id => ({
        id: Number(id),
      }));
      return CompraService.getFromRequisicaoProdutos(requisicoesProdutos)
        .then(({ data }) => {
          this.mapCompra(data);
        });
    },
    getCompraFromRequisicao() {
      return CompraService.getFromRequisicao(this.idRequisicao)
        .then(({ data }) => {
          this.mapCompra(data);
        });
    },
    onClickBack() {
      this.$refs.confirm.open(this.messageConfirm,
        'O rascunho ficara disponível na aba RASCUNHOS e TODAS da listagem de compras.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            this.$emit('update');
            if (this.idRequisicao) {
              this.$router.push({
                name: 'main.requiscao.detalhes',
                params: {
                  id: this.idRequisicao,
                },
              });
              return;
            }
            this.$router.back();
            return;
          }
          this.$emit('update');
          this.saveDraft();
        });
    },
    getCadastroAdicionalProduto(produto, tipo) {
      if (!produto.cadastrosAdicionais) {
        return {};
      }
      return getCadastroAdicional(produto.cadastrosAdicionais, tipo);
    },
    buildCadastrosAdicionaisProdutoPayload(produto) {
      if (this.checkCadastrosAdicionaisProduto(produto)) {
        return [];
      }
      return [
        produto.cadastrosAdicionais.armazem || this.getCadastroAdicionalProduto(produto.produto, 'ARMAZEM'),
        produto.cadastrosAdicionais.contaContabil || this.getCadastroAdicionalProduto(produto.produto, 'CONTA_CONTABIL'),
        produto.cadastrosAdicionais.contaFinanceira || this.getCadastroAdicionalProduto(produto.produto, 'CONTA_FINANCEIRA'),
      ].map((cadastro) => {
        if (cadastro) {
          return {
            id: cadastro.id,
          };
        }
        return null;
      }).filter(cadastro => cadastro);
    },
    buildCadastrosAdicionaisPayload() {
      if (this.checkCadastrosAdicionais) {
        return [];
      }
      return [
        this.cadastrosAdicionais.natureza,
        this.cadastrosAdicionais.condicaoPagamento,
        this.cadastrosAdicionais.tipoCobranca,
      ].map((cadastro) => {
        if (cadastro) {
          return {
            id: cadastro.id,
          };
        }
        return null;
      }).filter(cadastro => cadastro);
    },
    buildCompra() {
      const compra = { ...this.compra };
      compra.saving = calcularSaving(compra);
      compra.produtos = compra.produtos.map(produto => ({
        ...produto,
        id: produto.id ? produto.id : undefined,
        impostos: {
          ...produto.impostos,
          tipoAplicacaoIcms: getTipoAplicacaoIcms(produto.impostos.icms),
          tipoAplicacaoIpi: getTipoAplicacaoIpi(produto.impostos.ipi),
        },
        cadastrosAdicionais: this.buildCadastrosAdicionaisProdutoPayload(produto),
        tipoNotaEntrada: compra.tipoNotaEntrada || null,
      }));
      return {
        ...compra,
        mensagem: compra.mensagem,
        cadastrosAdicionais: this.buildCadastrosAdicionaisPayload(),
      };
    },
    buildDraftCompra() {
      const compra = { ...this.compra };
      compra.produtos = compra.produtos.filter(produto => !!produto.produto);
      compra.produtos = compra.produtos.map(produto => ({
        ...produto,
        id: produto.id ? produto.id : undefined,
        impostos: {
          ...produto.impostos,
          tipoAplicacaoIcms: getTipoAplicacaoIcms(produto.impostos.icms),
          tipoAplicacaoIpi: getTipoAplicacaoIpi(produto.impostos.ipi),
        },
        cadastrosAdicionais: this.buildCadastrosAdicionaisProdutoPayload(produto),
        tipoNotaEntrada: compra.tipoNotaEntrada,
      }));
      return {
        ...compra,
        mensagem: compra.mensagem,
        cadastrosAdicionais: this.buildCadastrosAdicionaisPayload(),
      };
    },
    saveDraft() {
      this.loading = true;
      CompraService.saveRascunho(this.buildDraftCompra())
        .then(() => {
          this.$toast('Rascunho salvo com sucesso', { color: 'success' });
          this.$router.push({ name: 'main.compras' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSalvar() {
      this.loading = true;
      CompraService.save(this.buildCompra(), this.compra.notificaFornecedor, this.isRascunho)
        .then(({ data }) => {
          this.$toast('Compra criada com sucesso', { color: 'success' });

          if (data.tipo === 'APROVACAO') {
            this.$router.push({
              name: 'main.aprovacao.detalhes',
              params: {
                id: data.id,
              },
            });
            return;
          }

          this.$router.push({
            name: 'main.compras.detalhes',
            params: { id: data.id },
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    beforeWindowUnload(e) {
      if (this.formDirty) {
        e.preventDefault();
        e.returnValue = '';
      }
    },
    getDetalhesFornecedor(id) {
      return GestaoFornecedorService.getByFornecedor(id)
        .then(({ data }) => {
          // fazer função auxiliar quando tiver mais opções de campos adicionais
          this.cadastrosAdicionais.natureza = getCadastroAdicional(data.cadastrosAdicionais,
            'NATUREZA');
        });
    },
    getCompradorDefaultFaturamento() {
      return CompradorService.getDefaultFaturamento()
        .then((response) => {
          this.compra.comprador = response.data;
        });
    },
    getCompradorDefaultEntrega() {
      return CompradorService.getDefaultEntrega()
        .then((response) => {
          this.compra.compradorEntrega = response.data;
        });
    },
    getNotaEntradaDefault() {
      if (this.compra.tipoNotaEntrada !== null) {
        return Promise.resolve();
      }
      return TipoNotaEntradaService.getNotaEntradaDefault()
        .then((response) => {
          this.compra.tipoNotaEntrada = response.data || null;
        });
    },
    getCamposObrigatorios() {
      EntidadeCamposCompraService.getCamposObrigatorios(this.erpCamposIntegracao)
        .then((data) => {
          this.camposObrigatorios = data;
        });
    },
  },
  created() {
    this.cadastrosAdicionais = initialStateCamposErp(this.erpCamposIntegracao);
    this.loadingForm = true;
    const getCompraPromise = this.getCompra();

    Promise.all([
      this.getCompradorDefaultEntrega(),
      this.getCompradorDefaultFaturamento(),
      getCompraPromise,
      this.getNotaEntradaDefault(),
    ])
      .finally(() => {
        this.loadingForm = false;
      });
    window.addEventListener('beforeunload', this.beforeWindowUnload);

    this.getCamposObrigatorios();
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
};
</script>
